
import { Inject, Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})

export class Services1Service {

  openBuild(){
    window.open('https://campus3d.utpl.edu.ec/app/mas/rei/', '_blank');
  }
  
}
